<template>
  <b-button v-if="accessRight" class="my-3 align-self-center FITButton pointer" :size="size" :variant="variant" :disabled="disabled" @click="onClick">
    <i v-if="faIcon" class="fa" :class="[faIcon, iconOnly?'':'pr-1' ]"></i> {{text}}
  </b-button>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'

export default {
  name: 'FTIButton',
  props: {
    size: String,
    variant: String,
    disabled: Boolean,
    text: String,
    faIcon: String,
    iconOnly:{
      default:false,
      type:Boolean,
    },
    accessLevel:
    {type: Number, default: 8}
  },
  data() {
    return {}
  },
  methods: {
    onClick(value) {
      this.$emit('click', value);
    }
  },
  computed:{
    accessRight(){
      let permissionLevel =this.$store.state.permissionLevel;
      if(permissionLevel <= this.accessLevel){
        return true;
      }else{
        return false;
      }
    }
  },
}

</script>
<style type="text/css">
.FITButton {
  font-weight: 500 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Button/FITButton.vue